import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../../../utils/date-range-options";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CHART_SUCCESS,
  FETCH_TABLE_SUCCESS,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_BOOKING_DATE,
  UPDATE_FUTURE_BOOKINGS,
  SET_DATES_FOR_FUTURE_BOOKING,
  UPDATE_FILTERS,
  REFETCH_FILTERS_SUCCESS,
  SET_DYNAMIC_FILTERS_STATUS,
  RESET_DYNAMIC_FILTERS_STATUS,
  SET_FIRST_EDITED_DYNAMIC_FILTER,
  dynamicFilters
} from "./bookingsSagas";

const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: {},
  tableData: {},
  dataPoints: [],
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  filters: {},
  pendingFilters: [],
  firstEditedDynamicFilter: "",
  selectedFilters: {
    booking_date: true,
    future_bookings: false,
    staff_ids: [],
    class_uids: [],
    class_time: [],
    status: [],
    group_by: []
  },
  rangeOptions: [],
  minDate: null,
  maxDate: null,
  selectedRangeOption: {}
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [SET_FIRST_EDITED_DYNAMIC_FILTER]: (state, action) => ({
      ...state,
      firstEditedDynamicFilter: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: [...rangeOptions, getSelectedRangeOptionWithCustom(action)],
        selectedRangeOption: getSelectedRangeOption(action.payload.endDate),
        minDate: state.currentUser.calendarStartDate,
        maxDate: null
      };
    },
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        group_by: action.payload.group_by.filter((val) => val.selected)[0]
      }
    }),
    [REFETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        group_by:
          action.payload?.group_by?.filter((val) => val.selected)[0] ||
          state.selectedFilters.group_by
      }
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [FETCH_TABLE_SUCCESS]: (state, { payload: { dataPoints = [], ...rest } }) => ({
      ...state,
      tableData: {
        ...rest,
        dateHeaderTooltip: state.selectedFilters.booking_date ? "Booking Date" : "Log Date"
      },
      dataPoints: dataPoints
    }),
    [UPDATE_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, [key]: data }
    }),
    [SET_DYNAMIC_FILTERS_STATUS]: (state, { payload }) => ({
      ...state,
      pendingFilters: payload
        ? dynamicFilters.filter((filterName) => filterName !== payload)
        : dynamicFilters
    }),
    [RESET_DYNAMIC_FILTERS_STATUS]: (state) => ({
      ...state,
      pendingFilters: []
    }),
    [UPDATE_BOOKING_DATE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        booking_date: action.payload
      }
    }),
    [UPDATE_FUTURE_BOOKINGS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        future_bookings: action.payload,
        booking_date: true,
        group_by: state.filters.group_by.filter((val) => val.selected)[0]
      }
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [SET_DATES_FOR_FUTURE_BOOKING]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload.selectedRequestDates,
      minDate: action.payload.minDate,
      maxDate: action.payload.maxDate,
      filtersDirty: true
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      pendingFilters: [],
      firstEditedDynamicFilter: "",
      selectedFilters: { ...initialState.selectedFilters }
    })
  },
  initialState
);
